import { useState } from 'react';

const testimonials = [
  {
    quote:
      'Pop Pro Tents® are always a pleasure to work with. Their creative ideas, professionalism, and logistical expertise are apparent from the ideation phase all the way through load-out.',
    name: 'Operations Manager',
    company: 'Firefly Music Festival / AEG Presents',
    initials: 'FM',
    color: 'bg-teal-500',
  },
  {
    quote:
      'Game changer. The landscape of our festival changed using Pop Pro Tents®. The process from beginning to end is seamless. This is a top notch vendor.',
    name: 'Director of Experience',
    company: 'C3 Presents',
    initials: 'C3',
    color: 'bg-emerald-500',
  },
  {
    quote:
      'We partner exclusively with Pop Productions to provide our events with incredible art installations and unique shade offerings that elevate any event experience.',
    name: 'Owner',
    company: 'BlackThorn Productions',
    initials: 'BP',
    color: 'bg-amber-500',
  },
  {
    quote:
      "From shade cover to stage builds, these tents have added a level of whimsy and fun that a standard white tent just can't compete with.",
    name: 'Senior Festival Producer',
    company: 'Insomniac',
    initials: 'IN',
    color: 'bg-rose-500',
  },
];

export default function TestimonialsCarousel() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < 2; i++) {
      items.push(testimonials[(current + i) % total]);
    }
    return items;
  };

  return (
    <section className="py-20 bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">What Our Clients Say</h2>
          <p className="text-gray-500 text-base">
            Trusted by event professionals across the country
          </p>
        </div>

        <div className="relative flex items-center gap-4">
          {/* Prev */}
          <button
            onClick={prev}
            className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full border border-gray-200 bg-white text-gray-500 hover:bg-teal-50 hover:border-teal-400 hover:text-teal-600 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          {/* Cards */}
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
            {getVisible().map((t, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-8 border border-gray-100"
              >
                <i className="ri-double-quotes-l text-4xl text-teal-100 block mb-4"></i>
                <p className="text-gray-700 text-base leading-relaxed mb-6 italic">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <div className={`w-11 h-11 flex items-center justify-center rounded-full ${t.color} text-white font-bold text-sm flex-shrink-0`}>
                    {t.initials}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{t.name}</p>
                    <p className="text-teal-500 text-xs font-medium">{t.company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Next */}
          <button
            onClick={next}
            className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full border border-gray-200 bg-white text-gray-500 hover:bg-teal-50 hover:border-teal-400 hover:text-teal-600 transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                i === current ? 'w-6 bg-teal-500' : 'w-2 bg-gray-300 hover:bg-teal-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
